module.exports = __webpack_public_path__ + "img/login_logo.5041dd41.png";